.toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0;
}

.tabsList {
    margin-left: calc(-1 * var(--mantine-spacing-md));
    margin-right: calc(-1 * var(--mantine-spacing-md));
}

.tabLabel {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.drawerContent {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.drawerBody {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.tabsRoot {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.tabsPanel {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

.tabCloseButton {
    display: inline-flex;
    align-items: center;
    margin-left: var(--mantine-spacing-xs);
    cursor: pointer;
    opacity: 0.5;
}

.tabCloseButton:hover {
    opacity: 1;
}
